/* hanzo.ee: Kaching Bundles can't hold per-market images, so its bars (and the
   gallery image it sets when a bar is selected) keep showing Lithuanian photos.
   layout/theme.liquid passes window.hzEeKaching.map = { "<EE product title>":
   { thumb, big } } for every product with an Estonian main image (metafield
   custom.main_image_ee). For each Kaching bar whose title matches a product:
   - swap the bar thumbnail to the Estonian image;
   - remember the bar's Kaching image file, and whenever Kaching puts that file
     into the product gallery, swap it to the Estonian image too.
   Bars without a matching product are left alone. */
(function () {
  'use strict';
  var data = window.hzEeKaching;
  if (!data || !data.map || !location.hostname.includes('hanzo.ee')) return;

  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  // "…/Kaching-Bundles-kr6_300x300.jpg?v=1" and "…/Kaching-Bundles-kr6.jpg?width=1946" -> "kaching-bundles-kr6"
  function fileBase(url) {
    var f = (url || '').split('?')[0].split('/').pop() || '';
    return f.replace(/\.[a-z0-9]+$/i, '').replace(/_\d+x\d*$/i, '').toLowerCase();
  }

  var byTitle = {};
  Object.keys(data.map).forEach(function (t) {
    byTitle[norm(t)] = data.map[t];
  });

  var kachingFileToImage = {}; // kaching file base -> { thumb, big }

  function swapBars() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var i = 0; i < bars.length; i++) {
      var titleEl = bars[i].querySelector('.kaching-bundles__bar-title');
      var ee = titleEl && byTitle[norm(titleEl.textContent)];
      if (!ee) continue;
      var imgs = bars[i].querySelectorAll('img.kaching-bundles__bar-image');
      for (var j = 0; j < imgs.length; j++) {
        var cur = imgs[j].getAttribute('src') || '';
        if (cur === ee.thumb) continue;
        if (/kaching-bundles/i.test(cur)) kachingFileToImage[fileBase(cur)] = ee;
        imgs[j].setAttribute('src', ee.thumb);
        imgs[j].removeAttribute('srcset');
      }
    }
  }

  function swapGallery() {
    var imgs = document.querySelectorAll('.product__media-list img, .product__media img, .product-media-modal img');
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || '';
      if (!/kaching-bundles/i.test(src)) continue;
      var ee = kachingFileToImage[fileBase(src)];
      if (!ee || src === ee.big) continue;
      imgs[i].setAttribute('src', ee.big);
      imgs[i].setAttribute('srcset', ee.big + ' 1946w');
    }
  }

  function apply() {
    swapBars();
    swapGallery();
  }

  apply();
  // Kaching mounts, re-renders and changes the gallery after load; re-apply on changes.
  new MutationObserver(apply).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['src', 'srcset'],
  });
})();
